import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { User, Mail, Lock, AlertCircle, ArrowRight, CheckCircle } from "lucide-react";
import Loginbackground from '../images/Registerlog.jpg'; // right side background image
import LeftBanner from '../images/the banner.png'; // left side image

const Register = () => {
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleRegistration = async () => {
    setError("");
    setSuccess("");
    setLoading(true);

    if (!userName.trim()) {
      setError("Username is required");
      setLoading(false);
      return;
    }
    if (!userEmail.trim() || !/\S+@\S+\.\S+/.test(userEmail)) {
      setError("Valid email is required");
      setLoading(false);
      return;
    }
    if (!password.trim() || password.length < 6) {
      setError("Password must be at least 6 characters long");
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      const requestBody = { userName, userEmail, password };
      const response = await axios.post(
        `https://api.dailyfit.ae/api/user/signup`,
        requestBody,
        { withCredentials: true }
      );

      console.log("Registration successful:", response.data);
      setSuccess("User registered successfully!");

      setTimeout(() => {
        navigate("/Order");
      }, 2000);
    } catch (error) {
      console.error("Registration Error:", error);
      const errorMessage =
        error.response?.data?.message || "An error occurred during registration";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-[#45827e]">
      {/* Left Side Image / Top Banner on Mobile */}
      <div className="w-full lg:w-1/2 bg-[#45827e] flex items-center justify-center overflow-hidden lg:sticky lg:top-0 lg:h-screen">
        <img
          src={LeftBanner}
          alt="Left Banner"
          className="w-full h-auto lg:h-full object-contain"
        />
      </div>


      {/* Right Side Registration Form with Background */}
      <div
        className="flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-12 relative min-h-screen overflow-y-auto"

      >
        <div className="relative z-10 w-full max-w-md p-6 sm:p-10 bg-white/70 border-2 border-white shadow-xl rounded-3xl backdrop-blur-sm my-8">
          <div className="text-center mb-6 sm:mb-8">
            <h2 className="text-2xl font-bold text-green-600 drop-shadow-sm mb-2">
              Create Account
            </h2>
            <p className="text-green-900/80">
              Fill in your details to start your fitness journey
            </p>
          </div>

          {/* Error & Success Messages */}
          {error && (
            <div className="bg-red-500/10 border-l-4 border-red-500 text-red-300 px-4 py-3 rounded-lg mb-6 flex items-center shadow-sm" role="alert">
              <AlertCircle className="w-5 h-5 mr-2 text-red-400" />
              <span>{error}</span>
            </div>
          )}
          {success && (
            <div className="bg-green-500/10 border-l-4 border-green-500 text-green-600 px-4 py-3 rounded-lg mb-6 flex items-center shadow-sm" role="alert">
              <CheckCircle className="w-5 h-5 mr-2 text-green-400" />
              <span>{success}</span>
            </div>
          )}

          {/* Form Fields */}
          <div className="space-y-6">
            <div className="relative group">
              <label htmlFor="username" className="block text-sm font-medium text-green-600 mb-1.5 ml-1">Username</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <User className="h-5 w-5 text-green-400 group-hover:text-green-600 transition-colors" />
                </div>
                <input
                  id="username"
                  type="text"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder="Enter your username"
                  className="w-full pl-12 pr-4 py-3.5 border border-green-400/30 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500/50 transition-all duration-300 shadow-sm"
                />
              </div>
            </div>

            <div className="relative group">
              <label htmlFor="email" className="block text-sm font-medium text-green-600 mb-1.5 ml-1">Email</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <Mail className="h-5 w-5 text-green-400 group-hover:text-green-600 transition-colors" />
                </div>
                <input
                  id="email"
                  type="email"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full pl-12 pr-4 py-3.5 border border-green-400/30 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500/50 transition-all duration-300 shadow-sm"
                />
              </div>
            </div>

            <div className="relative group">
              <label htmlFor="password" className="block text-sm font-medium text-green-600 mb-1.5 ml-1">Password</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-green-400 group-hover:text-green-600 transition-colors" />
                </div>
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="w-full pl-12 pr-12 py-3.5 border border-green-400/30 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500/50 transition-all duration-300 shadow-sm"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-4 flex items-center text-green-400 hover:text-green-600 transition-colors"
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            <div className="relative group">
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-green-600 mb-1.5 ml-1">Confirm Password</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <Lock className="h-5 w-5 text-green-400 group-hover:text-green-600 transition-colors" />
                </div>
                <input
                  id="confirmPassword"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm your password"
                  className="w-full pl-12 pr-12 py-3.5 border border-green-400/30 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500/50 transition-all duration-300 shadow-sm"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute inset-y-0 right-0 pr-4 flex items-center text-green-400 hover:text-green-600 transition-colors"
                >
                  {showConfirmPassword ? "Hide" : "Show"}
                </button>
              </div>
            </div>
          </div>

          <button
            onClick={handleRegistration}
            disabled={loading}
            className={`w-full mt-8 bg-gradient-to-r from-green-500 to-green-600 text-white py-3.5 px-4 rounded-xl flex items-center justify-center space-x-3 shadow-lg border border-green-400/30 transition-all duration-300 ${loading ? 'opacity-70 cursor-not-allowed' : 'hover:shadow-green-500/20 hover:shadow-xl'}`}
          >
            {loading ? "Registering..." : "Register"}
          </button>

          <div className="text-center mt-6">
            <p className="text-green-600">Already have an account?</p>
            <div
              onClick={() => navigate("/Order")}
              className="text-green-900 font-bold cursor-pointer hover:text-green-600 transition-colors mt-1 flex items-center justify-center group"
            >
              Sign in now
              <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
